module.exports = __webpack_public_path__ + "static/img/b1.68879a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/b1.jpg
// module id = j+PX
// module chunks = 0